import React from "react";
import QualityOfLifeComponent from "../../../components/Intelligence/QualityOfLife";

export default function QualityOfLifePage() {
    return <QualityOfLifeComponent />;
}
